import React from "react";
import InterviewerListItem from "./InterviewerListItem";
import "./InterviewerList.scss";
import PropTypes from "prop-types";

const InterviewerList = (props) => {
    const interviewers = props.interviewers.map((interviewer) => {
        return (
            <InterviewerListItem
                key={interviewer.id}
                name={interviewer.name}
                avatar={interviewer.avatar}
                setInterviewer={(event) => props.onChange(interviewer.id)}
                selected={interviewer.id === props.value}
            />
        );
    });

    return (
        <section className='interviewers'>
            <h4 className='interviewers__header text--light'>Interviewer</h4>
            <ul className='interviewers__list'>{interviewers}</ul>
        </section>
    );
}

InterviewerList.protoTypes = {
    interviewers: PropTypes.array.isRequired,
};

export default InterviewerList;
